/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedDrawPanel } from './ParsedDrawPanel';
import {
    ParsedDrawPanelFromJSON,
    ParsedDrawPanelFromJSONTyped,
    ParsedDrawPanelToJSON,
} from './ParsedDrawPanel';

/**
 * 
 * @export
 * @interface ParsedDrawBoard
 */
export interface ParsedDrawBoard {
    /**
     * 
     * @type {Array<ParsedDrawPanel>}
     * @memberof ParsedDrawBoard
     */
    panels: Array<ParsedDrawPanel>;
    /**
     * True when the numbers were auto-generated rather than player-picked.
     * @type {boolean}
     * @memberof ParsedDrawBoard
     */
    quickPick: boolean;
    /**
     * 
     * @type {number}
     * @memberof ParsedDrawBoard
     */
    boardId: number;
}

/**
 * Check if a given object implements the ParsedDrawBoard interface.
 */
export function instanceOfParsedDrawBoard(value: object): value is ParsedDrawBoard {
    if (!('panels' in value) || value['panels'] === undefined) return false;
    if (!('quickPick' in value) || value['quickPick'] === undefined) return false;
    if (!('boardId' in value) || value['boardId'] === undefined) return false;
    return true;
}

export function ParsedDrawBoardFromJSON(json: any): ParsedDrawBoard {
    return ParsedDrawBoardFromJSONTyped(json, false);
}

export function ParsedDrawBoardFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedDrawBoard {
    if (json == null) {
        return json;
    }
    return {
        
        'panels': ((json['panels'] as Array<any>).map(ParsedDrawPanelFromJSON)),
        'quickPick': json['quickPick'],
        'boardId': json['boardId'],
    };
}

export function ParsedDrawBoardToJSON(value?: ParsedDrawBoard | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'panels': ((value['panels'] as Array<any>).map(ParsedDrawPanelToJSON)),
        'quickPick': value['quickPick'],
        'boardId': value['boardId'],
    };
}

